import { render, staticRenderFns } from "./SmartTable.vue?vue&type=template&id=6bb6287c&scoped=true&"
import script from "./SmartTable.vue?vue&type=script&lang=js&"
export * from "./SmartTable.vue?vue&type=script&lang=js&"
import style0 from "./SmartTable.vue?vue&type=style&index=0&id=6bb6287c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6287c",
  null
  
)

export default component.exports